import React from 'react';
import { useNavigate } from "react-router-dom";
import PageHeader from "../common/ui/pageheader";

export default function Exbondheading() {
  const navigate = useNavigate();
  const isLoadingAutoFileNumber = false; // or from props/state

  const handleAddInbondClick = () => {
    // do your navigation or logic here
    navigate("/ex-bond/add-ex-bond");
  };

  return (
    <PageHeader
      title="Ex-bond"
      subtitle="Here you can record dispatch materials."
      buttonText="Add Ex-bond" // added text
      onButtonClick={handleAddInbondClick}
      disabled={isLoadingAutoFileNumber}
    />
  );
}
